const mvbody = document.body;
    let loaded = false;

    const onInteraction = () => {
      if (loaded === true) {
        return;
      }
      loaded = true;

      const modelViewer = document.createElement('script'); 
      modelViewer.type = 'module';
      modelViewer.src = '//www.hakii.com/cdn/shop/t/18/assets/model-viewer.min.js'; 
      mvbody.appendChild(modelViewer);
    };

    mvbody.addEventListener('mouseover', onInteraction, {once:true});
    mvbody.addEventListener('touchmove', onInteraction, {once:true});
    mvbody.addEventListener('scroll', onInteraction, {once:true});
    mvbody.addEventListener('keydown', onInteraction, {once:true});